import jwtService from '@/services/jwtService';
import { decryptData } from '@/utils/crypto'

export function isTokenExpired(expiresIn) {
    if (!expiresIn || typeof expiresIn !== 'number') return true;

    const currentTime = Math.floor(new Date().getTime() / 1000); // Current time in seconds
    checkTokenExpiration(expiresIn);
    return expiresIn < currentTime;
}

const checkTokenExpiration = (expiresIn) => {
    const currentTime = Math.floor(new Date().getTime() / 1000); // Current time in seconds since Unix epoch
    const timeDifference = expiresIn - currentTime; // Difference in seconds
    const minutesLeft = Math.floor(timeDifference / 60); // Convert seconds to minutes

    //console.log('Token expires in:', minutesLeft, 'minutes');

    // Return the minutes left
    return minutesLeft;
};
export function isAuthenticated() {
    try {
        const token = localStorage.getItem('token'); // Example: Check if a token exists in localStorage
        if (!token)
            return false;
        const jwtString = decryptData(token);
        if (!jwtString)
            return false;
        const jwt = jwtService.parseJwt(jwtString);
        if (!jwt.exp)
            return false;
        return !isTokenExpired(jwt.exp);
    }
    catch {
        return false;
    }
}

export function getUserRoles() {
    try {
        // Attempt to retrieve and decrypt the data from localStorage
        const userData = localStorage.getItem('token');

        // If there's no user data, return an empty array
        if (!userData) return [];

        // Decrypt and parse the JSON safely
        const decryptedData = decryptData(userData);
        const jwt = jwtService.parseJwt(decryptedData); // Fixed variable name

        // Extract roles from JWT - handle both array and single role
        let roles = [];

        // Check different possible role claims
        if (jwt.role) {
            if (Array.isArray(jwt.role)) {
                roles = jwt.role;
            } else if (typeof jwt.role === 'string') {
                roles = [jwt.role];
            }
        } else if (jwt.roles) {
            if (Array.isArray(jwt.roles)) {
                roles = jwt.roles;
            } else if (typeof jwt.roles === 'string') {
                roles = [jwt.roles];
            }
        }

        // Return roles if found, otherwise return an empty array
        return roles;
    } catch (error) {
        console.error('Error retrieving user roles:', error);
        return []; // Return empty array in case of an error
    }
}


function hasPosition(requiredRoles){
    try {
        // Attempt to retrieve and decrypt the data from localStorage
        const userData = localStorage.getItem('token');

        // If there's no user data, return an empty array
        if (!userData) return [];

        // Decrypt and parse the JSON safely
        const decryptedData = decryptData(userData);
        const jwt = jwtService.parseJwt(decryptedData); // Fixed variable name
        const position = jwt.Department;
        // Extract roles from JWT - handle both array and single role
        if(position?.toLowerCase() === 'super admin'){
            return true;
        }
        return requiredRoles.includes(position);
    } catch (error) {
        console.error('Error retrieving user roles:', error);
        return false;
    }
}

export function hasRoles(requiredRoles) {
    const haspos = hasPosition();
    if (haspos)
        return haspos;
    return requiredRoles.some((role) => getUserRoles().includes(role));
}

